var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsStarFillDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#E4E9F2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.635 17.5c-.132 0-.264-.03-.386-.094l-4.25-2.22-4.248 2.22c-.281.146-.621.121-.876-.065-.257-.187-.385-.503-.33-.815l.809-4.69L1.92 8.515c-.229-.221-.311-.553-.214-.856.098-.302.359-.523.673-.568l4.75-.69L9.255 2.13c.282-.567 1.21-.567 1.492 0L12.87 6.4l4.75.69c.315.045.575.266.673.568.098.303.015.635-.213.856l-3.434 3.32.81 4.69c.054.313-.075.629-.33.816-.146.106-.318.16-.491.16",
    transform: "translate(-1822 -1070) translate(1812.5 1060) translate(10 10)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStarFillDisable);
export default __webpack_public_path__ + "static/media/icons-star-fill-disable.ca3e019d.svg";
export { ForwardRef as ReactComponent };